'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPromoCode = setPromoCode;
exports.getPromoCode = getPromoCode;
exports.deletePromoCode = deletePromoCode;

var _docCookies = require('doc-cookies');

var _docCookies2 = _interopRequireDefault(_docCookies);

var _queryParam = require('@fr/query-param');

var _tldExtract = require('tld-extract');

var _tldExtract2 = _interopRequireDefault(_tldExtract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promoCodeName = 'promotionCode',
    promoCodeParam = 'ext_promoCode',
    hrefWithoutPort = _stripPort(),
    domain = (0, _tldExtract2.default)(hrefWithoutPort).domain;

/**
 * Sets the promo code, if any, in the cookies.
 */
/**
 * Helper functions related to dealing with promo code given to our partners.
 */

function setPromoCode() {

  var cookie = _docCookies2.default.getItem(promoCodeName),
      promoCode = (0, _queryParam.getParam)(promoCodeParam);

  if (promoCode) {

    // Sets the cookie only if needed (i.e it does not yet exists or it differs
    // from the one stored in the cookie.
    if (!cookie || cookie !== promoCode) {
      _docCookies2.default.setItem(promoCodeName, promoCode, 3600 * 24 * 7, null, domain);
    }
  }
}

/**
 * Gets the promo code, if any, from the cookies.
 */
function getPromoCode() {

  return _docCookies2.default.getItem(promoCodeName);
}

/**
 * Deletes the promo code, if any, from the cookies.
 */
function deletePromoCode() {
  _docCookies2.default.removeItem(promoCodeName, null, domain);
}

/**
 * Helper function to strip port number in case of local development.
 */
function _stripPort() {
  if (location.href.indexOf(':4200') > -1) {
    return location.href.substr(0, location.href.indexOf(':4200'));
  } else if (location.href.indexOf(':9000') > -1) {
    return location.href.substr(0, location.href.indexOf(':9000'));
  }
  return location.href;
}